import Image from "next/legacy/image";
import React from "react";
import RefundEmail from "public/assets/refund-policy/refund-email.png";
import BlurredSignForm from "public/assets/refund-policy/blurred-sign-form.png";
const KetentuanPengembalianDanaID: React.FC = () => (
  <>
    <h2>Data-data yang diperlukan:</h2>
    <ol type="1">
      <li>
        Nama Orang Tua yang sesuai dengan Nama Pemilik Rekening dan Pemilik NIK
      </li>
      <li>Kota Domisili</li>
      <li>Nomor Induk Kependudukan (NIK) No. telepon orang tua</li>
      <li>No. telepon orang tua</li>
      <li>Email orang tua</li>
      <li>
        No. Rekening, nama bank, dan nama pemilik rekening sesuai pemilik NIK
        yang diberikan
      </li>
      <li>Alasan tidak melanjutkan paket belajar</li>
    </ol>

    <p>
      Data-data yang diperlukan di atas dapat diisi pada:{" "}
      <a href="https://bit.ly/RefundFormCoLearn">
        https://bit.ly/RefundFormCoLearn
      </a>
    </p>

    <h2>Ketentuan untuk melakukan klaim:</h2>
    <ol type="1">
      <li>Berlaku untuk pembelian paket belajar CoLearn di bulan pertama</li>
      <li>Berlaku maks. 1 kali klaim untuk setiap murid </li>
      <li>
        Pastikan murid memiliki kehadiran 50% dari total kelas selama periode 1
        (satu) bulan tersebut. Khusus untuk paket belajar UTBK-SNBT, pastikan
        murid menghadiri kelas UTBK-SNBT minimal 1x pertemuan dari total
        pertemuan selama periode 1 (satu) bulan tersebut
      </li>
      <li>Pengembalian dana tidak berlaku untuk pembelian Tryout</li>
      <li>
        Pengembalian dana tidak dapat dilakukan jika sudah melewati periode 1
        bulan
      </li>
      <li>
        Khusus paket belajar reguler, pengembalian dana dapat dilakukan kurang
        dari 1 bulan jika memenuhi kriteria berikut:
        <ol type="a">
          <li>
            Murid memiliki kurikulum sekolah yang berbeda dengan yang digunakan
            di CoLearn
          </li>
          <li>
            Terdapat perbedaan materi pembelajaran dengan yang dipelajari di
            sekolah
          </li>
          <li>
            Murid terkendala waktu untuk menghadiri pembelajaran di kelas
            CoLearn karena berada di asrama atau jadwal kelas bertabrakan dengan
            jadwal lain
          </li>
        </ol>
      </li>
    </ol>

    <h2>Kemudian, ikuti langkah-langkah ini:</h2>
    <ol type="1">
      <li>Hubungi Kakak Siaga melalui nomor 0811-1910-3018 (chat WhatsApp)</li>
      <li>Kirimkan data-data lengkap yang dibutuhkan untuk klaim</li>
      <li>
        Form pengembalian dana akan dikirimkan ke email yang diberikan untuk
        ditandatangani oleh orang tua secara digital
      </li>
      <li>
        Pengembalian dana akan diproses dalam 7 hari kerja (tidak termasuk
        Sabtu, Minggu, dan hari libur nasional) setelah form pengembalian dana
        ditandatangani
      </li>
      <li>
        CoLearn akan mengirimkan bukti pembayaran melalui email yang diberikan
        sebelumnya, serta menginfokan pengembalian dana yang sudah diselesaikan
        melalui pesan WhatsApp
      </li>
    </ol>

    <h2>Tanya-jawab:</h2>
    <ol type="1">
      <li>
        <p style={{ marginBottom: 0 }}>
          Kapan saya dapat klaim garansi uang kembali?
        </p>
        <p style={{ margin: 0 }}>Jawab:</p>
        <p style={{ marginTop: 0 }}>
          Setelah putra-putri belajar di Bimbel CoLearn selama 1 bulan. Proses
          pengembalian dana dapat diajukan jika putra-putri merasa tidak puas
          dengan kelasnya pada 1 bulan pertama. Syarat kehadiran di kelas
          minimal 50% dari total kelas dan akan diproses saat paket Bimbel
          CoLearn telah berakhir.
        </p>
      </li>
      <li>
        <p style={{ marginBottom: 0 }}>Kenapa memerlukan NIK?</p>
        <p style={{ margin: 0 }}>Jawab:</p>
        <p style={{ marginTop: 0 }}>
          Proses pengembalian dana memerlukan NIK orang tua yg digunakan oleh
          tim CoLearn untuk memastikan bahwa dana dapat diterima orang tua murid
          yang tepat. CoLearn akan menjaga kerahasiaan dan keamanan data pribadi
          pelanggan sesuai aturan yang berlaku, jadi Bapak/Ibu tidak perlu
          khawatir.
        </p>
      </li>
      <li>
        <p style={{ marginBottom: 0 }}>
          Apa itu formulir garansi uang kembali?
        </p>
        <p style={{ margin: 0 }}>Jawab:</p>
        <p style={{ marginTop: 0 }}>
          Formulir tersebut berisikan data yang sebelumnya diberikan oleh
          Bapak/Ibu dan perlu ditandatangani secara digital. Form pengembalian
          dana akan dikirimkan melalui email yang diberikan.
        </p>
      </li>
      <li>
        <p style={{ marginBottom: 0 }}>
          Bagaimana cara menandatangani formulir tersebut?
        </p>
        <p style={{ margin: 0 }}>Jawab:</p>
        <p style={{ marginTop: 0 }}>
          Bapak/Ibu bisa klik &#39;Review & sign&#39; pada pesan masuk di email
          dan tanda tangan di bagian tanda tangan orang tua.
        </p>
        <div style={{ display: "flex", gap: "24px" }}>
          <Image
            src={RefundEmail}
            alt="Refund Email"
            layout="fixed"
            width={190}
            height={400}
          />
          <Image
            src={BlurredSignForm}
            alt="Blurred Sign Form"
            layout="fixed"
            width={250}
            height={400}
          />
        </div>
      </li>
      <li>
        <p style={{ marginBottom: 0 }}>
          Berapa lama proses pengembalian dana akan ditransfer?
        </p>
        <p style={{ margin: 0 }}>Jawab:</p>
        <p style={{ marginTop: 0 }}>
          Tim CoLearn akan memproses pengembalian dana kurang lebih selama 7
          hari kerja setelah formulir pengembalian dana ditandatangani oleh
          orang tua. Jika sudah ditransfer ke rekening yang diberikan, bukti
          transfer akan dikirimkan melalui email dan WhatsApp.
        </p>
      </li>
      <li>
        <p style={{ marginBottom: 0 }}>
          Apakah boleh mendaftar kembali ke Bimbel setelah sukses melakukan
          pengembalian dana?
        </p>
        <p style={{ margin: 0 }}>Jawab:</p>
        <p style={{ marginTop: 0 }}>
          Murid diperbolehkan mendaftar kembali di semester selanjutnya dengan
          catatan pengembalian dana 100% hanya bisa dilakukan satu kali. Jika
          murid yang sama mendaftar kembali di semester selanjutnya maka
          pengembalian dana tidak dapat diajukan.
        </p>
      </li>
    </ol>

    <p>
      Diperbarui pada: <strong>15th Maret 2024</strong>.
    </p>
  </>
);

export default KetentuanPengembalianDanaID;
